import { render, staticRenderFns } from "./carousel-promo-minimal.vue?vue&type=template&id=dce9bc20&scoped=true&"
import script from "./carousel-promo-minimal.vue?vue&type=script&lang=js&"
export * from "./carousel-promo-minimal.vue?vue&type=script&lang=js&"
import style0 from "./carousel-promo-minimal.vue?vue&type=style&index=0&id=dce9bc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce9bc20",
  null
  
)

export default component.exports